<template>
    <div class="class-management-box">
        <!-- 班级管理 -->
        <div class="nianji-box">
            <div class="fuzzy-matching-content">
                <el-button type="primary" @click="AddClick">新增组织</el-button>
                <el-button type="primary" @click="banjifanhui">返回</el-button>
            </div>
            <div class="fuzzy-matching-bottom">
                <el-table v-loading="loading"  class="table-Style" :header-cell-style="{ background: '#F4F7FC', color: '#000', }"
                    ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
                    @selection-change="handleSelectionChange">
                    <el-table-column prop="name" label="名称">
                    </el-table-column>
                    <el-table-column label="操作" min-width="100">
                        <template #default="scope">
                            <!-- <el-button type="text" size="small" @click="classManagement(scope.row)">修改班级</el-button> -->
                            <el-button type="text" size="small" class="searchBtn" @click="xiugaiClick(scope.row)">修改</el-button>
                            <el-button type="text" size="small" class="shanchuBtn"  @click="deleteClick(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="zuzhiblock-fenye">
                <el-pagination layout="prev, pager, next, jumper" :total="total" @size-change="handleSizeChange"
                    @current-change="handleCurrentChange" />
            </div>
        </div>
        <el-dialog class="dia-log-box" :title="title" v-model="dialogVisible" width="30%" :before-close="handleClose">
            <el-form ref="form" :model="form" :rules="rules">
                <el-form-item label="名称:" prop="schoolName" label-width="100px">
                    <el-input v-model="form.schoolName" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="备注:" label-width="100px">
                    <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.remark">
                    </el-input>
                </el-form-item>
                <div class="buttom-box">
                    <el-button type="primary" class="addForm" @click="onSubmit('form')">提交</el-button>
                    <el-button @click="handleClose">返回</el-button>
                </div>
            </el-form>

        </el-dialog>

    </div>
</template>

<script>
import {findClassList,addClass,findClassInfo,schoolClassupdate,schooldeleteClass} from '@/assets/api/renyuan';

export default {
    components: {

    },
    props: ['ClassObj'],
    data() {
        return {
            tableData: [
                {
                    name: '123123'
                }
            ],
            pageInfo: {
                pageSize: "10",
                page: "1",
            },
            total: '',
            classId:'',
            form: {
                remark: "",
                schoolName: ''
            },
            rules: {
                schoolName: [
                    { required: true, message: '请输入名称', trigger: 'blur' },
                ],
            },
            title: '新增组织',
            dialogVisible: false
        };
    },
    created() {
        // console.log( this.ClassObj,'班级传送');
        this.Classlist()
    },
    mounted() {

    },
    methods: {
        banjifanhui () {
            this.$emit('banjifanhui')
        },
        handleClose () {
            this.dialogVisible = false  
            this.Classlist()
        },
        // 校验
        onSubmit(formName) {
            // console.log(formName);
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.title == '修改组织') {
                        // console.log('修改', 8888);
                        this.classXiugai()
                    } else if (this.title == '新增组织') {
                        this.ClassAddForm()
                    }
                } else {
                    console.log('校验不通过');
                }

            });
        },
        // 删除
        deleteClick(item){
         schooldeleteClass(item.id).then((res)=> {
            this.$message({
                    type: 'success',
                    message: '删除成功'
                });
                this.Classlist()
            }).catch((err)=> {
                this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });

            })
        },
        //列表
        Classlist(){
            const params = {
                    page:this.pageInfo.page,
                    pageSize:this.pageInfo.pageSize
                    }
             findClassList(params,this.ClassObj.id).then((res)=> {
                this.tableData= res.data.data.list
                this.total = res.data.data.total
                // console.log(res,'班级列表');
                }).catch((err)=> {
                // console.log(err,'班级列表');

                })

        },
        // x新增弹框
        AddClick () {
            this.title = '新增组织'
            this.dialogVisible = true 
        },
        //新增
        ClassAddForm(){
            const params = {
                id:this.ClassObj.id,
                name:this.form.schoolName,
                remark:this.form.remark,
            }
            addClass(params).then((res)=> {
                // console.log(res,'新增成功');
                this.$message({
                    type: 'success',
                    message:"新增成功"
                });
                this.handleClose()
                
            }).catch((err)=> {
                // console.log(err,'新增失败');
                this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });

            }) 
        },
        // 修改弹框详情
        xiugaiClick(item) {
            this.title = '修改组织'
            this.dialogVisible = true     
            findClassInfo(item.id).then((res)=> {
            console.log(res,'修改');
            this.form.schoolName =res.data.data.name
            this.form.remark =res.data.data.description
            this.classId = res.data.data.id
        }).catch((err)=> {
            console.log(err,'xiugai');

        })
        },
        // 修改
        classXiugai(){
            const params = {
                id:this.classId,
                name:this.form.schoolName,
                remark:this.form.remark,
            }
         schoolClassupdate(params).then((res)=> {
            console.log(res,'修改成功');

                this.$message({
                    type: 'success',
                    message:"修改成功"
                });
                this.handleClose()
            }).catch((err)=> {
                console.log(err,'修改失败');
                this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });

            })

        },
   
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.pageInfo.page = val
            this.Classlist()
        },

    },
};
</script>

<style scoped lang="scss">
.class-management-box {
    height: 100%;
    padding-top: 20px;

    .nianji-box {
        height: 100%;
    }

    .fuzzy-matching-content {
        height: 20px;
        line-height: 20px;
        margin-bottom: 20px;

        /deep/ {
            .el-button {
                margin-left: 50px;
                font-size: 16px;
                height: 30px;
                // background-color: #1BC896;

            }
        }
    }

    .fuzzy-matching-bottom {
        // position: absolute;
        height: 70%;
        overflow: auto;
        padding: 20px;
        .table-Style{
            // border-radius: 15px;
        }
        .searchBtn{
            font-size: 15px;
            font-weight: 700;
            // color: #1BC896;
        }
        .shanchuBtn{
            font-size: 15px;
            font-weight: 700;
            color: red;
        }
        /deep/ {
            .el-table th.el-table__cell>.cell {
                height: 30px;
                line-height: 30px;
                text-align: center;
                font-size: 15px;
                font-weight: 700;
            }

            .el-table td.el-table__cell div {
                text-align: center;
                height: 40px;
                line-height: 40px;
                border: 0;
                font-size: 16px;
            }

            .el-table:not(.el-table--border) .el-table__cell {
                border: 0;
            }

            .el-button--small {
                padding-left: 19px;
            }
        }

    }

    .zuzhiblock-fenye {
        margin-left: 1000px;
        margin-top: 15px;
    }

    /deep/ {
        .el-dialog {

            .el-input--small .el-input__wrapper {
                height: 35px;
                line-height: 35px;
                text-align: center;
                width: 280px;
            }

            .el-input__inner {
                // width: 10px !important;
            }

            .buttom-box {
                // text-align: center;
                margin-left: 180px;
                .addForm{
        // background-color: #1BC896;
    }


            }

            .el-form-item--small {
                width: 70% !important;
            }
        }
    }
}
</style>
